import React from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import 'antd/dist/reset.css';

function App() {
  return (
    <div className="App">
      <Dashboard />
    </div>
  );
}

export default App;
